import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';
const cmdEnvsUrl = `${baseUrl}/${service}/batterymanagement/cmdEnvs`;

// Vendor command envs, POST body = { data: [dto, ...] }
class CmdEnvsService extends ServiceBase {
    _config = () => ({
        headers: {
            Authorization: `Bearer ${this.getToken()}`,
            'Content-Type': 'application/json',
        },
    });

    /** @returns {Promise} last known command envs per vendor instance */
    getCmdEnvs = () => agent.get(cmdEnvsUrl, this._config());

    /** @param {object[]} dto - [{ app, machine, envs }], full set of envs per vendor instance */
    postCmdEnvs = (dto) => agent.post(cmdEnvsUrl, { data: dto }, this._config());
}

const cmdEnvsService = new CmdEnvsService();
export default cmdEnvsService;
